'use strict';

exports.__esModule = true;

var _getCustomTagsString = require('./custom/get-custom-tags-string');

Object.keys(_getCustomTagsString).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getCustomTagsString[key];
    }
  });
});

var _updateCustomTags = require('./custom/update-custom-tags');

Object.keys(_updateCustomTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _updateCustomTags[key];
    }
  });
});

var _validateCustomTags = require('./custom/validate-custom-tags');

Object.keys(_validateCustomTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _validateCustomTags[key];
    }
  });
});

var _applyDefaultTags = require('./defaults/apply-default-tags');

Object.keys(_applyDefaultTags).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _applyDefaultTags[key];
    }
  });
});

var _getByIdentifier = require('./defaults/get-by-identifier');

Object.keys(_getByIdentifier).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getByIdentifier[key];
    }
  });
});

var _validateByIdentifier = require('./validations/validate-by-identifier');

Object.keys(_validateByIdentifier).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _validateByIdentifier[key];
    }
  });
});

var _getByIdentifier2 = require('./values/get-by-identifier');

Object.keys(_getByIdentifier2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getByIdentifier2[key];
    }
  });
});

var _getFromHtmlTag = require('./values/get-from-html-tag');

Object.keys(_getFromHtmlTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getFromHtmlTag[key];
    }
  });
});

var _updateByIdentifier = require('./values/update-by-identifier');

Object.keys(_updateByIdentifier).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _updateByIdentifier[key];
    }
  });
});